import clsx from 'clsx';

type Tone = 'ok' | 'warn' | 'crit' | 'muted';

export function StatusDot({ tone, pulse = false }: { tone: Tone; pulse?: boolean }) {
  return (
    <span
      className={clsx(
        'inline-block h-2.5 w-2.5 rounded-full',
        tone === 'ok' && 'bg-cockpit-ok',
        tone === 'warn' && 'bg-cockpit-warn',
        tone === 'crit' && 'bg-cockpit-crit',
        tone === 'muted' && 'bg-cockpit-dim',
        pulse && tone !== 'muted' && 'animate-pulse-dot',
      )}
      aria-label={`status: ${tone}`}
    />
  );
}
